document.addEventListener('DOMContentLoaded', function() {
  // Track phone number clicks
  var phoneTrackingId = ['G-20EQT7D81B','AW-649682032/OLfDCMbJx50YEPC45bUC'];
  var phoneLinks = document.querySelectorAll('a[href^="tel:"]');
  phoneLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      var phoneLinkUrl = this.href;
      var phoneLinkText = this.text;
      gtag('event', 'click_phone', { 'send_to': phoneTrackingId, 'outbound': false, 'method': 'phone', 'link_url': phoneLinkUrl, 'link_text': phoneLinkText });
      // Shopify.analytics.publish('phone_link', { link_url: phoneLinkUrl, link_text: phoneLinkText });
    });
  });

  // Track email link clicks
  var emailTrackingId = ['G-20EQT7D81B','AW-649682032/GR9MCMnJx50YEPC45bUC'];
  var emailLinks = document.querySelectorAll('a[href^="mailto:"]');
  emailLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      var emailLinkUrl = this.href;
      var emailLinkText = this.text;
      gtag('event', 'click_email', { 'send_to': emailTrackingId, 'outbound': false, 'method': 'email', 'link_url': emailLinkUrl, 'link_text': emailLinkText });
      // Shopify.analytics.publish('email_link', { link_url: emailLinkUrl, link_text: emailLinkText });
    });
  });
});